<template>
    <div>
        <div class="rounded bg-white shadow-md mb-4">
            <div class="border-b-2 border-followup-nav py-2 px-3 bg-primary text-white">
                <span>
                    Sage 100 Income vs Cost

                    <span class="cursor-disabled" v-if="project.sage_project_no && loadingVistaIncomeCostData">
                        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </span>
                    <span class="cursor-pointer" v-if="project.sage_project_no && !loadingVistaIncomeCostData"
                        @click="syncProjectVistaInvoice(true)">
                        <i class="fa fa-rotate-right" aria-hidden="true"></i>
                    </span>
                    <span v-if="project.sage_project_no" class="float-right">
                        <button
                            class="btn btn-primary text-xs p-0 px-1 bg-white text-teal hover:text-black shadow-none active:text-black"
                            @click.prevent="openVistaIncomeCostDetailModal()" style="color:#4dc0b5 !important; ">View
                            Details</button>
                    </span>
                    <span v-else class="float-right">
                        <button
                            class="btn btn-primary text-xs p-0 px-1 bg-white text-red hover:text-black shadow-none active:text-black"
                            @click.prevent="syncProjectFromAgave">Link Job</button>
                    </span>
                </span>
            </div>
            <div class="pb-0 px-3">
                <div class="row py-2 text-sm border-b-1">
                    <div class="col-md-8 text-left">
                        Income
                    </div>
                    <div class="col-md-4 text-right">
                        {{ getSafe(() => vistaIncomeCostData.totalIncome) || '$0.00' }}
                    </div>
                </div>
                <div class="row py-2 text-sm border-b-1">
                    <div class="col-md-8 text-left">
                        Expense
                    </div>
                    <div class="col-md-4 text-right">
                        {{ getSafe(() => vistaIncomeCostData.totalExpenses) || '$0.00' }}
                    </div>
                </div>
                <div class="row py-2 text-sm">
                    <div class="col-md-8 text-left">
                        Profit
                    </div>
                    <div class="col-md-4 text-right">
                        {{ getSafe(() => vistaIncomeCostData.profit) || '$0.00' }}
                    </div>
                </div>
            </div>
            <!-- <div class="pt-4 pb-2 px-3 text-center">
                No invoice detail found
            </div> -->
        </div>

        <div class="modal fade" id="vistaIncomeCostModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header border-b-0">
                        <h5 class="modal-title" id="exampleModalLongTitle">Sage 100 Income Vs Cost Details <span class="cursor-pointer" @click="sync()"><i class="fa fa-refresh" aria-hidden="true"></i></span></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white pb-5" v-if="!loadingData">
                        <nav class="px-8 pt-2 mb-8 border-b-0 border-teal bg-grey-lighter">
                            <div class="flex nav" id="tabs">
                                <a class="text-base hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8 active"
                                   href="#Overview" aria-controls="Overview" role="tab" data-toggle="tab">
                                    Overview
                                </a>
                                <a class="text-base hover:no-underline hover:text-followup-nav no-underline text-grey-darkest border-b-2 border-transparent tracking-wide text-sm py-3 mr-8"
                                   href="#Transactions" aria-controls="Transactions" role="tab" data-toggle="tab">
                                    Transactions
                                </a>
                            </div>
                        </nav>
                        <div class="tab-content flex" v-if="vistaIncomeCostData">
                            <div role="tabcard" class="tab-pane active w-full px-3" id="Overview">
                                <div class="custom-container">
                                    <div class="custom-column">
                                        <p class="text-3xl font-weight-bolder">{{ vistaIncomeCostData.totalIncome }}</p>
                                        <p class="font-weight-bold text-grey-darkest text-lg">INCOME</p>
                                    </div>

                                    <div class="custom-column">
                                        <img style="width: 50px;margin: 0 auto;" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/minus.png">
                                    </div>

                                    <div class="custom-column">
                                        <p class="text-3xl font-weight-bolder text-grey-darkest">{{ vistaIncomeCostData.totalExpenses}}</p>
                                        <p class="font-weight-bold text-grey-darkest text-lg">COSTS</p>
                                    </div>

                                    <div class="custom-column">
                                        <img style="width: 50px;margin: 0 auto;" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/equal.png">
                                    </div>

                                    <div class="custom-column">
                                        <p class="text-3xl font-weight-bolder text-grey-darkest">{{ vistaIncomeCostData.profit }}</p>
                                        <p class="font-weight-bold text-grey-darkest text-lg">PROFIT</p>
                                    </div>
                                </div>
                                <div class="custom-container-data">
                                    <div class="custom-column-data border-0 p-0 text-white text-left text-sm">
                                        <div class="bg-teal p-2 w-full">
                                            Income <span class="text-right float-right">{{ vistaIncomeCostData.totalIncome}}</span>
                                        </div>
                                        <div v-if="vistaIncomeCostData.groupedTotalIncome" v-for="(item, index) in vistaIncomeCostData.groupedTotalIncome" class="p-2 w-full border-1 border-t-0 text-grey-darkest">
                                            {{index}} <span class="text-right float-right">{{ item}}</span>
                                        </div>
                                    </div>

                                    <div class="custom-column-data">
                                        <img style="width: 50px;margin: 0 auto;visibility: hidden" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/minus.png">
                                    </div>

                                    <div class="custom-column-data border-0 p-0 text-white text-left text-sm">
                                        <div class="bg-teal p-2 w-full">
                                            Expenses <span class="text-right float-right">{{vistaIncomeCostData.totalExpenses}}</span>
                                        </div>
                                        <div v-if="vistaIncomeCostData.groupedTotalExpenses" v-for="(expense, expenseKey) in vistaIncomeCostData.groupedTotalExpenses" class="p-2 w-full border-1 border-t-0 text-grey-darkest">
                                            {{expenseKey}} <span class="text-right float-right">{{ expense}}</span>
                                        </div>
                                    </div>

                                    <div class="custom-column-data">
                                        <img style="width: 50px;margin: 0 auto;visibility: hidden" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/minus.png">
                                    </div>

                                    <div class="custom-column-data border-0 p-0 text-white text-left text-sm">
                                    </div>
                                </div>
                            </div>
                            <div role="tabcard" class="tab-pane w-full px-3" id="Transactions">
                                <table id="qb-transaction" class="table table-bordered qb-transaction-table" v-if="vistaIncomeCostData.transactions.length > 0">
                                    <thead>
                                        <tr>
                                            <th scope="col">DATE</th>
                                            <th scope="col">TYPE</th>
                                            <th scope="col">NO.</th>
                                            <th scope="col">DUE DATE</th>
                                            <th scope="col">BALANCE</th>
                                            <th scope="col">TOTAL</th>
                                            <th scope="col">STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="transaction in vistaIncomeCostData.transactions" class="font-weight-normal text-sm">
                                            <th class="font-weight-normal text-sm">{{ (transaction.date)? transaction.date :'' }}</th>
                                            <td class="font-weight-normal text-sm">{{ (transaction.transaction_type)? transaction.transaction_type:'' }}</td>
                                            <td class="font-weight-normal text-sm">{{ (transaction.number)? transaction.number:'' }}</td>
                                            <td class="font-weight-normal text-sm">{{ (transaction.due_date)? transaction.due_date:'' }}</td>
                                            <td class="font-weight-normal text-sm">{{ transaction.balance }}</td>
                                            <td class="font-weight-normal text-sm">{{ transaction.total }}</td>
                                            <td class="font-weight-normal text-sm">{{ transaction.status }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p v-else class="text-center text-2xl text-black">No Transaction Found</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body bg-white text-center text-black text-lg" v-else>
                        <i class="fa fa-spin fa-spinner text-grey-darkest text-4xl text-teal" aria-hidden="true"></i><br>
                        Loading Sage 100 Income Vs Cost Details
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'sage-100-income-vs-cost',
    props: ['project'],
    components: {},
    data() {
        return {
            vistaIncomeCostData: null,
            loadingVistaIncomeCostData: false,


            loadingData: false,
            cost: {},
            income: {},
            costTotal: 0,
            incomeTotal: 0,
            profit: 0,
            transactions: [],
            costOfGoodsSold: 0,
            bill: {},
            billTotal: 0,
            hourlyTimeCost: {},
            hourlyTimeCostTotal: 0,
            incomeDiscount: 0,
        }
    },
    mounted() {
        if(this.project.sage_project_no){
            this.syncProjectVistaInvoice();
        }

        let dataTableScript = document.createElement("script");
        dataTableScript.setAttribute("src", "https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js");
        document.head.appendChild(dataTableScript);

        let dataTable4Script = document.createElement("script");
        dataTable4Script.setAttribute("src", "https://cdn.datatables.net/1.13.6/js/dataTables.bootstrap4.min.js");
        document.head.appendChild(dataTable4Script);
    },
    created() {

    },
    methods: {
        syncProjectFromAgave(){
            this.$parent.$refs.ProjectSageComponent.syncProjectFromAgave();
        },
        openVistaIncomeCostDetailModal(){
            this.openIncomeCostModal();
        },
        syncProjectVistaInvoice(refresh = false){
            this.loadingVistaIncomeCostData = true;
            if(refresh){
                this.getToast().fire({
                    type: 'success',
                    title: 'Syncing income summary'
                });
            }
            axios.post(route('api.sage100.fetch-project-income-cost-data'), {projectId: this.project.id, pullNew: refresh}).then((response) => {
                console.log("fetch invoice data", response)
                this.loadingVistaIncomeCostData = false;
                if(response.data.status == 'success'){
                    this.vistaIncomeCostData = response.data.incomeCostData;
                    if(response.data.syncedNow){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        openIncomeCostModal(){
            $('#vistaIncomeCostModal').modal('show');
        },
        closeModal(){
            $('#vistaIncomeCostModal').modal('hide');
        },
        sync(){
            // this.loadingData = true;
            this.syncProjectVistaInvoice();
        }
    }
}
</script>
<style scoped>
.custom-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.custom-column {
    flex: 1;
    margin: 5px 10px;
    padding: 5px 10px;
    border: 1px solid black;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.custom-column:nth-child(2),
.custom-column:nth-child(4) {
    flex: 0.13;
    border: none;
}
.custom-container-data {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
}

.custom-column-data {
    flex: 1;
    margin: 5px 10px;
    padding: 5px 10px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.custom-column-data:nth-child(2),
.custom-column-data:nth-child(4) {
    flex: 0.1;
    border: none;
}

table.table.table-bordered.qb-transaction-table thead th {
    background-color: #f1f5f8 !important;
    border-bottom: 0 !important;
}

</style>
<style>
#qb-transaction_filter{
    display: none !important;
}
.paginate_button {
    padding: 2px !important;
    background: #f6f7f7;
    cursor: pointer;
    border-radius: 5px;
    margin: 0 1px;
    text-decoration: none;
}

.paginate_button:hover {
    padding: 2px !important;
    background: #38b2b0 !important;
    color: white !important;
    cursor: pointer;
    text-decoration: none;
}
</style>